import { SpeciesType } from 'app/constants/species';
import { ProcessingOptions } from 'app/native/node-addons/imageProcessing';
import { BONES_REGIONS } from 'app/utils/xrayRegions';
import _ from 'lodash';

const CAT_THORAX_OPTIONS = {
  intensities: [0.6, 0.6, 0.7, 0.7, 0.7, 0.7, 0.7, 0.7, 0.7, 0.8, 0.9, 1.0],
  denoise_intensities: [0.25, 0.25, 0.25, 0.34, 0.34, 0.34, 0.34, 0.34, 0.34, 0.0, 0.0, 0.0],
  black_relative_steepness: 1.0,
  white_relative_steepness: 2.5,
  general_steepness: 1.4,
  centering_quantile: 70 / 100,
};

const PROCESSING_OPTIONS: Record<string, ProcessingOptions> = {
  default: { ...CAT_THORAX_OPTIONS },
  dog_abdomen: {
    intensities: [0.6, 0.6, 0.7, 0.75, 0.8, 0.8, 0.8, 0.8, 0.8, 0.8, 0.9, 1],
    denoise_intensities: [0.25, 0.25, 0.2, 0.2, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0],
    black_relative_steepness: 1.2,
    white_relative_steepness: 1.5,
    general_steepness: 2,
    centering_quantile: 50 / 100,
  },
  cat_abdomen: {
    intensities: [0.6, 0.6, 0.7, 0.8, 0.8, 0.8, 0.8, 0.8, 0.8, 0.8, 0.9, 1.0],
    denoise_intensities: [0.25, 0.25, 0.25, 0.34, 0.34, 0.34, 0.34, 0.34, 0.34, 0.0, 0.0, 0.0],
    black_relative_steepness: 1.2,
    white_relative_steepness: 1.5,
    general_steepness: 2,
    centering_quantile: 50 / 100,
  },
  bones: {
    intensities: [0.49, 0.55, 0.6, 0.65, 0.7, 0.75, 0.75, 0.8, 0.8, 0.8, 0.9, 1.0],
    denoise_intensities: [0.5, 0.6, 0.7, 0.8, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    black_relative_steepness: 1.0,
    white_relative_steepness: 3.0,
    general_steepness: 1.3,
    centering_quantile: 40 / 100,
  },
  dog_skull: {
    intensities: [0.42, 0.48, 0.53, 0.63, 0.7, 0.75, 0.75, 0.8, 0.8, 0.8, 0.9, 1.0],
    denoise_intensities: [0.5, 0.6, 0.7, 0.8, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    black_relative_steepness: 1.3,
    white_relative_steepness: 3.0,
    general_steepness: 1.4,
    centering_quantile: 55 / 100,
  },
  dog_thorax: {
    intensities: [0.6, 0.6, 0.7, 0.7, 0.7, 0.8, 0.8, 0.8, 0.8, 0.8, 0.9, 1.0],
    denoise_intensities: [0.25, 0.0, 0.0, 0.2, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    black_relative_steepness: 1.0,
    white_relative_steepness: 2.5,
    general_steepness: 1.8,
    centering_quantile: 70 / 100,
  },
  cat_thorax: { ...CAT_THORAX_OPTIONS },
};

Object.freeze(PROCESSING_OPTIONS);

export const PROCESSING_OPTIONS_LIST = [
  { id: 'default', parameters: PROCESSING_OPTIONS.default },
  { id: 'cat_thorax', parameters: PROCESSING_OPTIONS.cat_thorax },
  {
    id: 'dog_abdomen',
    parameters: PROCESSING_OPTIONS.dog_abdomen,
  },
  {
    id: 'cat_abdomen',
    parameters: PROCESSING_OPTIONS.cat_abdomen,
  },
  { id: 'bones', parameters: PROCESSING_OPTIONS.bones },
  {
    id: 'dog_skull',
    parameters: PROCESSING_OPTIONS.dog_skull,
  },
  {
    id: 'dog_thorax',
    parameters: PROCESSING_OPTIONS.dog_thorax,
  },
];

export type ProcessingFiltersAssociationBySpecieAndRegion = {
  [key in SpeciesType | 'all']?: Record<string, string>;
};

export const DEFAULT_PROCESSING_ASSOCIATION_BY_SPECIE_AND_REGION: ProcessingFiltersAssociationBySpecieAndRegion =
  {
    all: {
      default: 'default',
      abdomen: 'cat_abdomen',
      thorax: 'cat_thorax',
      bones: 'bones',
      // ..._.fromPairs(BONES_REGIONS.map((region) => [region, 'bones'])),
    },
    dog: {
      abdomen: 'dog_abdomen',
      thorax: 'dog_thorax',
      'bones crane': 'dog_skull',
    },
    cat: {
      abdomen: 'cat_abdomen',
      thorax: 'cat_thorax',
    },
  } as const;

export default PROCESSING_OPTIONS;
